// src/pages/HomePage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import refrigeratorImg from "../assets/images/refrigeratorMainPage.png";
import acImg from "../assets/images/ACMainPage.png";
import washingMachineImg from "../assets/images/WashingMachineMainPage.png";
import othersImg from "../assets/images/othersMainPage.png";

const categories = [
  { title: "Refrigerator", img: refrigeratorImg },
  { title: "Air Conditioner", img: acImg },
  { title: "Washing Machine", img: washingMachineImg },
  { title: "Other Appliances", img: othersImg },
];

function HomePage() {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/category/${encodeURIComponent(category)}`);
  };

  return (
    <div className="home-root">
      {/* Banner */}
      <section className="home-banner"></section>

      {/* About Section */}
      <section className="home-about">
        <h2>About Us</h2>
        <p>
          VICON Products & Services is a trusted name in high-quality spare
          parts and accessories for home appliances. We offer a reliable range
          of products for refrigerators, air conditioners, washing machines,
          microwaves, and more, designed to support better performance, safety,
          and longer appliance life. Our products are built for compatibility,
          durability, and easy replacement across leading appliance brands. With
          a focus on quality and customer satisfaction, VICON supports dealers,
          distributors, retailers, and service professionals with dependable
          spare part solutions.
        </p>
      </section>

      {/* Categories */}
      <section className="home-categories">
        <h2>Product Categories</h2>
        <div className="categories-grid">
          {categories.map((cat) => (
            <div
              className="category-card"
              key={cat.title}
              onClick={() => handleCategoryClick(cat.title)}
              style={{ cursor: "pointer" }}
            >
              <img src={cat.img} alt={cat.title} className="category-img" />
              <div className="category-title">{cat.title}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default HomePage;
